module.exports = __webpack_public_path__ + "img/slider2.caf53030.gif";